module.exports = __webpack_public_path__ + "static/media/theme-minimal-no-drop-targets.31d68875.svg";